import { render, staticRenderFns } from "./TipButton.vue?vue&type=template&id=cb7602d4&scoped=true&lang=pug&"
import script from "./TipButton.vue?vue&type=script&lang=js&"
export * from "./TipButton.vue?vue&type=script&lang=js&"
import style0 from "./TipButton.vue?vue&type=style&index=0&id=cb7602d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb7602d4",
  null
  
)

export default component.exports